import { render, staticRenderFns } from "./buildings.vue?vue&type=template&id=aa806e40&"
import script from "./buildings.vue?vue&type=script&lang=js&"
export * from "./buildings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports